import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { FormBuilder,UntypedFormControl, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { InventoryService } from '../../services/inventory.service'
import { PrintService } from '../../services/print.service'
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DropzoneComponent, DropzoneDirective, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-special-pricing',
	templateUrl: './special-pricing.component.html',
	styleUrls: ['./special-pricing.component.scss']
})
export class SpecialPricingComponent implements OnInit {
	@ViewChild('specEdit') specEditRef: ElementRef;
	@ViewChild('specUp') specUpload: ElementRef;


	searchSpecials = new UntypedFormControl('');
	blanket = new UntypedFormControl('');
	/** Sentinel for items with no brand in multi-select. */
	readonly brandNoneKey = '__NO_BRAND__';
	brandOptions: string[] = [];
	filterForm: FormGroup;
	allinactive: any[] = [];
	itemdetails: any = false;
	imsearch: any= false;
	color = 'blue';
	active: any = [];
	inactive: any = [];
	stockid: any = null;
	pricelvs: any = [];
	prices_array: any = [];
	original_prices_array: any = [];
	defaulttype: any = '2';
	allitems: any = [];
	filteredOptions: any = [];
	files: any = [];
	uploaddata: any = [];
	specialForm: FormGroup;
	mapcols: any = [{ 'field': 'stockid', label: 'Item Number' },
		{ 'field': 'startdate', label: 'Start Date' },
		{ 'field': 'enddate', 'label': 'End Date' },
		{ 'field': 'limit', 'label': 'Qty Limit' },
		{ 'field': 'baseprice', 'label': 'Blanket Price' },
		{ 'field': 'qoh', 'label': 'Use QOH' },
		{ 'field': 'andor','label': 'Special Type' }
	];
	mapping: any = {};
	selectedItem: any = false;
	editing = false;
	allactive: any[] = [];
	config: any = false;

	
	constructor(public printService: PrintService, private fb: FormBuilder, private inventoryService: InventoryService, private globalSearchService: GlobalSearchService, private location: Location, public cdr: ChangeDetectorRef, private modalService: NgbModal, private datePipe: DatePipe) {
		this.color = this.globalSearchService.getColor();
		this.filterForm = this.fb.group({
			brands: [[] as string[]],
			ageMin: [''],
			ageMax: [''],
			qohMin: [''],
			qohMax: [''],
		});
	}

	ngOnInit(): void {

		this.globalSearchService.configsubscription.subscribe((res) => {
			this.config = res;
		})

		this.globalSearchService.all_system_types.subscribe((alltypes: any) => {
			if (alltypes) {
				this.pricelvs = alltypes.salestypes;
				for (let x = 0; x < this.pricelvs.length; x++) {
					this.mapcols.push({ 'field': 'price_' + this.pricelvs[x].typeabbrev, 'label': this.pricelvs[x].sales_type })
				}
			}
		});

		this.blanket.valueChanges.subscribe( newValue => {
			if(this.prices_array.length) {
				this.prices_array.forEach(p => {
					p.price = newValue;
				})
			}
		});

		this.filterForm.valueChanges.subscribe(() => this.applyFilters());
	}

	selectItem(stockid: any) {
		this.inventoryService.loadItem(stockid).subscribe((results: any) => {
			this.itemdetails = results;
		});
	}


	itemSearch(): void {
		this.applyFilters();
	}

	private brandKey(row: any): string {
		const b = (row?.brand ?? '').toString().trim();
		return b === '' ? this.brandNoneKey : b;
	}

	brandLabel(key: string): string {
		return key === this.brandNoneKey ? '(No brand)' : key;
	}

	rebuildBrandOptions(): void {
		const set = new Set<string>();
		for (const r of this.allactive || []) {
			set.add(this.brandKey(r));
		}
		for (const r of this.allinactive || []) {
			set.add(this.brandKey(r));
		}
		this.brandOptions = Array.from(set).sort((a, b) => {
			if (a === this.brandNoneKey) {
				return 1;
			}
			if (b === this.brandNoneKey) {
				return -1;
			}
			return a.localeCompare(b, undefined, { sensitivity: 'base' });
		});
	}

	selectAllBrands(): void {
		this.filterForm.patchValue({ brands: [...this.brandOptions] }, { emitEvent: true });
	}

	selectNoBrands(): void {
		this.filterForm.patchValue({ brands: [] }, { emitEvent: true });
	}

	clearRangeFilters(): void {
		this.filterForm.patchValue(
			{ ageMin: '', ageMax: '', qohMin: '', qohMax: '' },
			{ emitEvent: true }
		);
	}

	private parseFilterNum(v: any): number | null {
		if (v === '' || v === null || v === undefined) {
			return null;
		}
		const n = Number(v);
		return Number.isFinite(n) ? n : null;
	}

	private filterRows(source: any[]): any[] {
		let rows = [...(source || [])];
		const term = (this.searchSpecials.value ?? '').toString().trim();
		if (term) {
			rows = this.globalSearchService.filterItem(
				rows,
				term,
				'stockid,description,brand,rawsize,mfgpart,categoryid,lineid'
			);
		}
		const brands = this.filterForm.get('brands')?.value as string[] | undefined;
		if (brands?.length) {
			const set = new Set(brands);
			rows = rows.filter((r) => set.has(this.brandKey(r)));
		}
		const ageMin = this.parseFilterNum(this.filterForm.get('ageMin')?.value);
		const ageMax = this.parseFilterNum(this.filterForm.get('ageMax')?.value);
		const qohMin = this.parseFilterNum(this.filterForm.get('qohMin')?.value);
		const qohMax = this.parseFilterNum(this.filterForm.get('qohMax')?.value);
		rows = rows.filter((r) => {
			const age = Number(r?.age);
			const qoh = Number(r?.qoh);
			if (ageMin !== null) {
				if (Number.isNaN(age) || age < ageMin) {
					return false;
				}
			}
			if (ageMax !== null) {
				if (Number.isNaN(age) || age > ageMax) {
					return false;
				}
			}
			if (qohMin !== null) {
				if (Number.isNaN(qoh) || qoh < qohMin) {
					return false;
				}
			}
			if (qohMax !== null) {
				if (Number.isNaN(qoh) || qoh > qohMax) {
					return false;
				}
			}
			return true;
		});
		return rows;
	}

	applyFilters(): void {
		this.active = this.filterRows(this.allactive);
		this.inactive = this.filterRows(this.allinactive);
	}

	addSpecial() {
		this.itemdetails = false;
		this.editing = false;
		this.prices_array = [];
		this.pricelvs.forEach(x => this.addList(x, 0));

		this.specialForm = this.fb.group({
			specialid: [''],
			stockid: ['', Validators.required],
			startdate: ['', Validators.required],
			enddate: ['', Validators.required],
			qtylimit: [0, Validators.required],
			qtysold: [0],
			andor: [this.defaulttype],
			clearsold: [0],
			nfd: [false],
		});

		this.setValiditiy();

		this.autocompleteFilter();
		this.modalService.open(this.specEditRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {
			this.itemdetails = false;
		});
	}

	autocompleteFilter() {

		if(this.imsearch) {
			this.imsearch.unsubscribe()
		}

		const data = {
			stockid: this.specialForm.get('stockid').value
		};

		this.imsearch = this.inventoryService.itemSearch(data).subscribe(results => {

			const no_zero = results.filter( r => {
				return parseFloat(r.qty) > 0
			})
			this.allitems = no_zero;
			this.filteredOptions = no_zero;
		});

	}
	setValiditiy() {

		switch(this.specialForm.get('andor').value) {
		case '1':
			this.specialForm.get('startdate').setValidators([Validators.required])
			this.specialForm.get('startdate').updateValueAndValidity();

			this.specialForm.get('enddate').setValidators([Validators.required])
			this.specialForm.get('enddate').updateValueAndValidity();

			break;
		default:
			this.specialForm.get('startdate').setValidators([])
			this.specialForm.get('startdate').updateValueAndValidity();

			this.specialForm.get('enddate').setValidators([])
			this.specialForm.get('enddate').updateValueAndValidity();
			break;
		}
	}
	addList(x: any, y: any) {

		if (!y) {
			y = 0;
		}

		const price = {
			typeabbrev: x.typeabbrev,
			sales_type: x.sales_type,
			price: y,
		}

		this.prices_array.push(price);

	}

	setForm() {

	}

	validate() {
		let proc = true;

		if(this.specialForm.get('andor').value == '2') {
			if(parseFloat(this.specialForm.get('qtylimit').value) > 0 ) {

			} else {
				alert('Qty Can not be zero while using QTY');
				proc = false;
			}
		}

		return proc;
	}

	private buildSpecialsExportRows(): Record<string, string | number>[] {
		const rows: Record<string, string | number>[] = [];
		for (const p of this.active || []) {
			const row: Record<string, string | number> = {
				'Stock ID': p.stockid ?? '',
				'Raw Size': p.rawsize ?? '',
				Brand: p.brand ?? '',
				Manufacturer: p.manufacturer ?? '',
				'Brand code': p.mfgpart_brand ?? '',
				'Mfg Part': p.mfgpart ?? '',
				Category: p.categoryid ?? '',
				'Product Line': p.lineid ?? '',
				Sort: p.sort ?? '',
				'Sort 2': p.sort2 ?? '',
				'Tire size': p.tire_size ?? '',
				'Tire mfg': p.tire_mfg ?? '',
				Description: p.description ?? '',
				'Start Date': this.datePipe.transform(p.startdate, 'shortDate') ?? '',
				'End Date': this.datePipe.transform(p.enddate, 'shortDate') ?? '',
				Remaining: p.qtyleft ?? '',
				QOH: p.qoh ?? '',
				Age: p.age ?? '',
			};
			for (const lv of this.pricelvs || []) {
				const ta = lv?.typeabbrev;
				const label = lv?.sales_type || ta;
				if (!label) {
					continue;
				}
				const raw = ta && p.prices ? p.prices[ta] : null;
				row[label] = raw != null && raw !== '' ? Number(raw) : '';
			}
			rows.push(row);
		}
		return rows;
	}

	private escPdf(v: any): string {
		if (v === null || v === undefined) {
			return '';
		}
		return String(v)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	private buildSpecialsExportHtml(): string {
		let html = '<table class="table table-sm table-bordered"><thead><tr>';
		html += '<th>Stock ID</th><th>Raw Size</th><th>Brand</th><th>Manufacturer</th><th>Brand code</th><th>Mfg Part</th>';
		html += '<th>Category</th><th>Product Line</th><th>Sort</th><th>Sort 2</th><th>Tire size</th><th>Tire mfg</th>';
		html += '<th>Description</th><th>Start Date</th><th>End Date</th><th>Remaining</th><th>QOH</th><th>Age</th>';
		for (const lv of this.pricelvs || []) {
			if (lv?.sales_type) {
				html += `<th>${this.escPdf(lv.sales_type)}</th>`;
			}
		}
		html += '</tr></thead><tbody>';
		for (const p of this.active || []) {
			html += '<tr>';
			html += `<td class="text-left">${this.escPdf(p.stockid)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.rawsize)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.brand)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.manufacturer)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.mfgpart_brand)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.mfgpart)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.categoryid)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.lineid)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.sort)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.sort2)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.tire_size)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.tire_mfg)}</td>`;
			html += `<td class="text-left">${this.escPdf(p.description)}</td>`;
			html += `<td class="text-center">${this.escPdf(this.datePipe.transform(p.startdate, 'shortDate'))}</td>`;
			html += `<td class="text-center">${this.escPdf(this.datePipe.transform(p.enddate, 'shortDate'))}</td>`;
			html += `<td class="text-center">${this.escPdf(p.qtyleft)}</td>`;
			html += `<td class="text-center">${this.escPdf(p.qoh)}</td>`;
			html += `<td class="text-center">${this.escPdf(p.age)}</td>`;
			for (const lv of this.pricelvs || []) {
				const ta = lv?.typeabbrev;
				const raw = ta && p.prices ? p.prices[ta] : null;
				const disp = raw != null && raw !== '' ? Number(raw).toFixed(2) : '';
				html += `<td class="text-right">${this.escPdf(disp)}</td>`;
			}
			html += '</tr>';
		}
		html += '</tbody></table>';
		return html;
	}

	exportSpecialsXlsx(): void {
		const rows = this.buildSpecialsExportRows();
		if (!rows.length) {
			return;
		}
		const stamp = new Date().toISOString().slice(0, 10);
		this.globalSearchService.exportJsonToExcel(rows, `Specials_${stamp}.xlsx`);
	}

	exportSpecialsPdf(): void {
		if (!this.active?.length) {
			return;
		}
		const stamp = new Date().toISOString().slice(0, 10);
		const content = this.globalSearchService.base64encode(this.buildSpecialsExportHtml());
		const data = {
			content,
			filename: `Specials_${stamp}.pdf`,
			title: 'Item Specials',
			subtitle: `Exported ${new Date().toLocaleString()} · ${this.active.length} row(s)`,
		};
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

	editSpecial(spec: any) {
		this.editing = true;
		this.prices_array = [];
		this.inventoryService.getItemSpecial(spec).subscribe((results: any) => {
			this.selectItem(results.stockid);

			this.pricelvs.forEach(x => this.addList(x, results.prices[x.typeabbrev]));

			this.specialForm = this.fb.group({
				specialid: [results.specialid],
				stockid: [results.stockid, Validators.required],
				startdate: [results.startdate, Validators.required],
				enddate: [results.enddate, Validators.required],
				qtylimit: [results.qtylimit, Validators.required],
				qtysold: [results.qtysold],
				clearsold: [0],
				andor: [results.andor],
				nfd: [results.nfd],
			});
			this.setValiditiy();
			this.autocompleteFilter();
			//this.original_prices_array = results.prices;
			this.modalService.open(this.specEditRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {

			});
		});
	}

	specialByStockID() {


		const data = { stockid: this.specialForm.get('stockid').value };
		this.inventoryService.getStockItemSpecial(data).subscribe((results: any) => {
			if (results) {
				this.prices_array = [];

				this.pricelvs.forEach(x => this.addList(x, results.prices[x.typeabbrev]));

				this.specialForm = this.fb.group({
					specialid: [results.specialid],
					stockid: [results.stockid, Validators.required],
					startdate: [results.startdate, Validators.required],
					enddate: [results.enddate, Validators.required],
					qtylimit: [results.qtylimit, Validators.required],
					qtysold: [results.qtysold],
					clearsold: [0],
					andor: ['2'],
					nfd: [false],
				});
				this.setValiditiy();
			}
		});

	}
	saveSpecial() {

		//let data = this.specialForm.value;
		if(this.specialForm.valid && this.validate()) {
			const data = {
				specialid: this.specialForm.get('specialid').value,
				stockid: this.specialForm.get('stockid').value,
				startdate: this.specialForm.get('startdate').value,
				enddate: this.specialForm.get('enddate').value,
				qtylimit: this.specialForm.get('qtylimit').value,
				clearsold: this.specialForm.get('clearsold').value,
				andor: this.specialForm.get('andor').value,
				prices: this.prices_array,
				nfd: this.specialForm.get('nfd').value,
			};

			this.inventoryService.saveItemSpecial(data).subscribe((results: any) => {
				this.editing = false;
				this.allactive = results.active;
				this.allinactive = results.inactive;
				this.rebuildBrandOptions();
				this.applyFilters();
				this.modalService.dismissAll();
			});
		}
	}

	removeSpecial(data: any) {
		this.inventoryService.removeItemSpecial(data).subscribe((results: any) => {
			this.allactive = results.active;
			this.allinactive = results.inactive;
			this.rebuildBrandOptions();
			this.applyFilters();
			this.modalService.dismissAll();
		});
	}

	uploadSpecial() {
		this.modalService.open(this.specUpload, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}
	sendSpecials() {
		const data = { tabledata: this.uploaddata, mapping: this.mapping };
		this.inventoryService.sendItemSpecials(data).subscribe((results: any) => {
			this.allactive = results.active;
			this.allinactive = results.inactive;
			this.rebuildBrandOptions();
			this.applyFilters();
			this.modalService.dismissAll();
		});
	}
	onUploadError(event: any) {

	}

	onUploadSuccess(event: any) {

	}
	onSelect(event: any) {
		this.files.push(...event.addedFiles);
		for (let i = 0; i < this.files.length; i++) {
			this.readFile(this.files[i]).then(fileContents => {
				//stuff

				const upload = {
					content: fileContents,
					name: event.addedFiles[0].name,
					mime: event.addedFiles[0].type,
				}

				this.inventoryService.uploadSpecials(upload).subscribe((results: any) => {
					this.uploaddata = results;

					this.files = [];
				});

			});
		}
	}
	ngAfterViewInit() {
		this.inventoryService.getSpecialsData().subscribe((results: any) => {
			this.allactive = results.active || [];
			this.allinactive = results.inactive || [];
			this.defaulttype = results.defaulttype;
			this.rebuildBrandOptions();
			this.applyFilters();
		});
	}

	back(): void {
		this.location.back()
	}

	filterItem(input: any, term: any, keys: any) {
		const result = Object.assign([], input).filter((item) => keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(term, 'gi').test(item[key])));
		return result
	}

	private async readFile(file: File): Promise < string | ArrayBuffer > {
		return new Promise < string | ArrayBuffer > ((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = e => {
				return resolve((e.target as FileReader).result);
			};

			reader.onerror = e => {
				console.error(`FileReader failed on file ${file.name}.`);
				return reject(null);
			};

			if (!file) {
				return reject(null);
			}
			reader.readAsDataURL(file);
		});

		this.files = [];
	}
}
